var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"va-list-separator",class:{
      'va-list-separator--offset': !_vm.fit,
      'va-list-separator--spaced': _vm.spaced
    }})])}
var staticRenderFns = []

export { render, staticRenderFns }